import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faTwitter as faTwitterBrand,
  faLinkedinIn,
  faInstagram as faInstagramBrand,
} from "@fortawesome/free-brands-svg-icons";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const products = ["High Alumina Firebricks", "IS-8", "POURING REFRACTORIES"];

  const socialLinks = [
    { icon: faFacebookF, url: "#", name: "Facebook" },
    { icon: faTwitterBrand, url: "#", name: "Twitter" },
    { icon: faLinkedinIn, url: "#", name: "LinkedIn" },
    { icon: faInstagramBrand, url: "#", name: "Instagram" },
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            {/* Company Info with Logo */}
            <div className="footer-section">
              <div className="footer-logo-section">
                <img
                  src="/logo.png"
                  alt="Ramkrishna Refractories Logo"
                  className="footer-logo-img"
                />
              </div>
            </div>
            <div className="footer-section">
              <h4>Ramkrishna Refractories</h4>
              <p>
                Recognized manufacturer of high-quality firebricks for
                industrial and commercial applications. With wast of experience,
                we deliver innovative refractory solutions.
              </p>
              <div className="social-links">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    className="social-link"
                    aria-label={social.name}
                  >
                    <FontAwesomeIcon icon={social.icon} />
                  </a>
                ))}
              </div>
            </div>

            {/* Products */}
            <div className="footer-section">
              <h4>Our Products</h4>
              <ul>
                {products.map((product, index) => (
                  <li key={index}>
                    <Link to="/products">{product}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-section">
              <h4>Contact Information</h4>
              <div className="contact-info">
                <div className="contact-item">
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                  <div>
                    <p>Opp. Railway Station, Visipara</p>
                    <p>Wankaner - 363621</p>
                    <p>Gujarat, India</p>
                  </div>
                </div>
                <div className="contact-item">
                  <FontAwesomeIcon icon={faPhone} />
                  <div>
                    <p>+91 94081 86116</p>
                  </div>
                </div>
                <div className="contact-item">
                  <FontAwesomeIcon icon={faEnvelope} />
                  <div>
                    <p>rkrwankaner@yahoo.co.in</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>
              &copy; {currentYear} Ramkrishna Refractories. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <Link to="#">Privacy Policy</Link>
              <Link to="#">Terms of Service</Link>
              <Link to="#">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
